import { ApiService, toModel, toModels } from '~/shared/api'
import { AgreementsSignature } from '~/models/agreements'
import { API_PREFIX } from '~/shared/const/request-services'
import type { AgreementsSignatureDto } from '~/shared/types/agreements'

export class AgreementsSignaturesService extends ApiService {
  readonly url = `${API_PREFIX}/agreements/signatures`

  getListModel(params: Record<string, unknown> = {}): Promise<AgreementsSignature[]> {
    return this.http.request({ url: this.url, params }).then(toModels(AgreementsSignature))
  }

  createModel(dto: AgreementsSignatureDto): Promise<AgreementsSignature> {
    return this.http
      .request({ url: this.url, method: 'POST', data: dto })
      .then(toModel(AgreementsSignature))
  }
}
